import { formStrings } from '@utils/forms';
import { DEFAULT_PAGE_SIZE } from '@utils/types';
import { sumBy } from 'remeda';
import { z } from 'zod';

export const PaginationType = z.object({
  page: z.number().optional(),
  page_size: z
    .number()
    .optional()
    .formMeta({ label: formStrings.pageSize, getInitialOutput: () => DEFAULT_PAGE_SIZE }),
  selected: z.any().array().optional(),
  format: z.enum(['csv']).optional(),
});

export type PaginationType = z.infer<typeof PaginationType>;

export type PaginationResults<T> = {
  count: number;
  results: T[];
};

export const getNextPageParam = <T, Data extends PaginationResults<T>>(
  lastPage: Data,
  allPages: Data[],
) => {
  return lastPage.count > sumBy(allPages, (p) => p.results.length)
    ? {
        queries: {
          page: allPages.length + 1,
        },
      }
    : undefined;
};
